import { render, staticRenderFns } from "./StudiesMenu.vue?vue&type=template&id=3a1a53da"
import script from "./StudiesMenu.vue?vue&type=script&lang=js"
export * from "./StudiesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports